import React, { createContext, useContext, useState, useEffect } from "react";

type UserRole = "Director" | "CoordProyectos" | "Financiera";

interface DashboardLink {
  label: string;
  url: string;
}

interface UserSession {
  usuario: string;
  rol: UserRole;
  links: DashboardLink[];
}

interface AuthContextType {
  user: UserSession | null;
  login: (userData: { usuario: string; rol: string }) => void;
  logout: () => void;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const PBI_PROJECTS = "https://app.powerbi.com/view?r=eyJrIjoiM2Q0YjUwMmMtY2QzOC00YzgwLTg2ZTMtYWRmMjA3MjVlNTczIiwidCI6IjkwOTk2N2YyLTJhNTMtNGMzYS1iNDIxLWZmNGQxMThiYWJjYyIsImMiOjR9";
const PBI_ALMACEN = "https://app.powerbi.com/view?r=eyJrIjoiODVlOWRhYjAtOTgyMS00MjRjLWFiYWYtNDI2MDg2MmE0NmQ1IiwidCI6IjkwOTk2N2YyLTJhNTMtNGMzYS1iNDIxLWZmNGQxMThiYWJjYyIsImMiOjR9";

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<UserSession | null>(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("fnc_user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem("fnc_user");
      }
    }
  }, []);

  const login = (userData: { usuario: string; rol: string }) => {
    const rol = userData.rol as UserRole;
    let links: DashboardLink[] = [];

    if (rol === "Director" || rol === "Financiera") {
      links = [
        { label: "Proyectos", url: PBI_PROJECTS },
        { label: "Almacén", url: PBI_ALMACEN },
      ];
    } else {
      links = [
        { label: "Proyectos", url: PBI_PROJECTS },
      ];
    }

    const session: UserSession = {
      usuario: userData.usuario,
      rol,
      links,
    };

    setUser(session);
    localStorage.setItem("fnc_user", JSON.stringify(session));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("fnc_user");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
